import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  RouteObject,
  Navigate,
} from "react-router-dom";
import MainRoutes from "./main_routes";
import LoginRoutes from "./login_routes";
import { useAuth } from "../shared/hooks";
import ErrorPage from "./ErrorPage"; // 👈 import it

const RootRedirect = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated() ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootRedirect />,
    errorElement: <ErrorPage />,   // 👈 add error page here
  },
  {
    ...MainRoutes,
    errorElement: <ErrorPage />,   // 👈 also add here
  },
  ...LoginRoutes.map(route => ({
    ...route,
    errorElement: <ErrorPage />,   // 👈 add for login routes too
  })),
  {
    path: "*",
    element: <Navigate to="/" />,
    errorElement: <ErrorPage />,   // 👈 fallback also safe
  },
];

const Router: React.FC = () => {
  const router = createBrowserRouter(routes);
  return <RouterProvider router={router} />;
};

export default Router;
